<template>
  <div class="contentData" v-show="showS">
    <div class="title">
      <img src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_60b994b335302/417794106.png" alt="">
      <span>暂无数据</span>
    </div>
    <div class="desc">请更换条件后检索数据</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showS: false
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  created() {},
  mounted() {},
  methods: {
    showFalse() {
      this.showS = false
      this.$emit('update:show', false)
    }
  },
  watch: {
    // show: {
    //   handler(newName, oldName) {
    //     console.log('show', newName)
    //     this.showS = newName
    //   },
    //   // 代表在wacth里声明了firstName这个方法之后立即先去执行handler方法
    //   immediate: true
    // }
    show(obj) {
      // console.log('show', obj)
      this.showS = obj
    }
  }
}
</script>
<style lang="less" scoped>
.contentData{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, .87);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 100;
  color: #8A96A3;
  .title{
    display: flex;
    align-items: center;
    img{
      width: 80px;
      margin-right: 10px;
    }
    span{
      font-size: 20px;
      color: #8A96A3;
    }
  }
  .desc{
    margin-top: 10px;
    font-size: 14px;
  }
}
</style>
